<template>
  <div>
    <div
      :style="{ backgroundColor: bgColor, color: textColor }"
      class="main-chip"
    >
      {{ title }}
    </div>
  </div>
</template>

<script>
export default {
  name: "MainBadge",
  components: {},
  props: {
    title: String,
    variant: {
      type: String,
      default: "green",
    }, // 'green' | 'blue' |'red'
  },
  computed: {
    bgColor() {
      let bgColor = "#B1DF8D";
      if (this.variant == "green") {
        bgColor = "#B1DF8D";
      }
      if (this.variant == "blue") {
        bgColor = "#70CED4";
      }
      if (this.variant == "red") {
        bgColor = "#FF7878";
      }

      if (this.variant == "gray") {
        bgColor = "#F4F4F4";
      }
      return bgColor;
    },
    textColor() {
      return this.variant == "gray" ? "#000000" : "#FFFFFF";
    },
  },
};
</script>
